import React from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';

const PlanningDateNavigator = ({ currentDate, navigateDay, onDateSelect }) => {
  const handleDateChange = (event) => {
    const selectedDate = event.target.value;
    if (selectedDate && onDateSelect) {
      onDateSelect(selectedDate);
    }
  };

  // Format current date for input value (YYYY-MM-DD)
  const formatDateForInput = (date) => {
    const d = new Date(date);
    return d.toISOString().split('T')[0];
  };

  return (
    <div className="absolute right-40 top-3 z-20">
      <div className="flex items-center gap-1 rounded-lg border border-gray-200/50 bg-white/90 p-1 shadow-sm backdrop-blur-sm lg:gap-2">
        <button
          onClick={(e) => {
            e.stopPropagation();
            navigateDay(-1);
          }}
          className="flex-shrink-0 rounded-md p-1.5 transition-colors hover:bg-gray-100 lg:p-2"
          aria-label="Previous day"
          onMouseDown={(e) => e.preventDefault()} // Prevent focus on input
        >
          <ChevronLeftIcon className="h-3 w-3 text-gray-600 lg:h-4 lg:w-4" />
        </button>

        <input
          type="date"
          value={formatDateForInput(currentDate)}
          onChange={handleDateChange}
          className="min-w-0 flex-shrink-0 rounded-md border-0 bg-transparent px-2 py-1 text-center text-xs font-medium text-gray-700 transition-colors focus:bg-gray-50 focus:outline-none lg:px-3 lg:text-sm"
          style={{ width: '120px' }}
        />

        <button
          onClick={(e) => {
            e.stopPropagation();
            navigateDay(1);
          }}
          className="flex-shrink-0 rounded-md p-1.5 transition-colors hover:bg-gray-100 lg:p-2"
          aria-label="Next day"
          onMouseDown={(e) => e.preventDefault()} // Prevent focus on input
        >
          <ChevronRightIcon className="h-3 w-3 text-gray-600 lg:h-4 lg:w-4" />
        </button>
      </div>
    </div>
  );
};

export default PlanningDateNavigator;
